<div class="header-wrapper">
  <nav class="header-nav">
    <!-- Left Section: Logo & Menu -->
    <div class="header-left">
      <a [routerLink]="['/']" class="logo-link">
        <img
          *ngIf="!logoImage"
          src="assets/images/logo.png"
          alt="logo"
          class="logo-img"
        />
        <img
          *ngIf="logoImage"
          [src]="logoImage"
          alt="logo"
          class="logo-img"
        />
      </a>
        <button class="menu-btn" (click)="togglediv()" aria-label="Toggle Menu">
        <i class="fas fa-bars"></i>
      </button>
    </div>

    <!-- Right Section: Actions -->
    <div class="header-right">
      <!-- Date -->
      <div class="date-display">
        <i class="far fa-calendar-alt"></i>
        <span class="date-text">{{ currentDate }}</span>
      </div>

      <!-- User Profile Dropdown -->
      <div class="user-dropdown" dropdown>
        <button class="user-profile-btn" dropdownToggle type="button" id="userDropdown" aria-haspopup="true" aria-expanded="false">
          <div class="user-info">
            <span class="user-role">Admin</span>
            <span class="user-name">{{ appUserAuth?.firstName }} {{ appUserAuth?.lastName }}</span>
          </div>
          <img
            *ngIf="appUserAuth?.profilePhoto"
            [src]="profilePath"
            alt="User Avatar"
            class="user-avatar"
          />
          <img
            *ngIf="!appUserAuth?.profilePhoto"
            src="assets/images/user-profile.jpg"
            alt="User Avatar"
            class="user-avatar"
          />
          <i class="fas fa-chevron-down dropdown-arrow"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="userDropdown">
          <a class="dropdown-item" [routerLink]="['/my-profile']">
            <i class="far fa-user"></i>
            <span>Profile</span>
          </a>
          <a class="dropdown-item" href="javascript:void(0)">
            <i class="fas fa-cog"></i>
            <span>Settings</span>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item logout-item" (click)="onLogout()">
            <i class="fas fa-power-off"></i>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </div>
  </nav>
</div>
